import React from 'react';
import { Form, Input } from 'antd';
import { BringgFontIcons, BringgIcon } from '@bringg/bringg-icons';
import { FilterContentProps } from '../types';

export const FilterDropdownSearch = ({ name, placeholder, onFilterChange }: FilterContentProps) => (
	<Form.Item name={name}>
		<Input
			// TODO: with new antd version we will be able to use our own icon for clear
			allowClear
			onChange={onFilterChange}
			placeholder={placeholder}
			prefix={<BringgIcon className="search-icon" iconName={BringgFontIcons.Search} />}
		/>
	</Form.Item>
);
